<template>
    <b-modal id="make_copy_subscriber_modal" @ok="createSubscriber">
        <template slot="modal-title">Make a copy of {{this.subscriber_name}}</template>
        <form ref="make_copy_subscriber_form">
            <b-form-group
                    label="Event"
                    label-for="event">
                <b-form-select
                        id="event"
                        :state="validateEvent"
                        v-model="eventName"
                        :options="event_options"
                        required/>
                <b-form-invalid-feedback :state="validateEvent">
                    Select an event.
                </b-form-invalid-feedback>
            </b-form-group>
        </form>
    </b-modal>
</template>

<script>
    import SubscriberRepository from '../../repositories/subscriber.repository';

    export default {
        props: {
            event_options: {
                type: Array,
                default: () => []
            },
            subscriber_id: {
                type: Number,
                default: -1,
            },
            subscriber_name: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                eventName: ''
            }
        },
        methods: {
            checkFields() {
                if (SubscriberRepository.validate.event(this.eventName) === false) return false;
                return true;
            },
            createSubscriber(modal) {
                if (this.$refs.make_copy_subscriber_form.checkValidity() && this.checkFields()) {
                    this.$emit('show-loading-pop-up', 'Making a copy of the selected subscriber.');
                    SubscriberRepository.makeCopy(this.subscriber_id, this.eventName).then(res => {
                        this.$emit('reset-loading-pop-up');
                        if (res.status === 200) {
                            // Emit the subscriber created event
                            this.$emit('subscriber-created', res.data.data);
                            // Notify the user.
                            this.$bvToast.toast(`Subscriber ${res.data.data.name} successfully created.`, {
                                title: `Subscriber created.`,
                                variant: 'success',
                                solid: true
                            });
                            this.eventName = '';
                        } else {
                            this.$bvToast.toast('Looks like something went wrong while creating a new subscriber.', {
                                title: `Subscriber creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    }).catch(error => {
                        this.$emit('reset-loading-pop-up');
                        if (error.response.status === 422) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while validating the new subscriber. Check the value\'s of all the fields', {
                                title: `Subscriber validation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText);
                            this.$bvToast.toast('Looks like something went wrong on the server while creating a new subscriber.', {
                                title: `Subscriber creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    });
                } else {
                    modal.preventDefault();
                }
            }
        },
        computed: {
            validateEvent() {
                return SubscriberRepository.validate.event(this.eventName);
            }
        }
    }
</script>
